export default [
  {
    title: 'بازرگانان',
    icon: 'bx bx-store',
    children: [
      {
        title: 'بازرگانان',
        route: { name: 'merchant' },
        resource: 'MerchantManager',
        action: 'show',
      },
    ],
  },
]
